import PropTypes from 'prop-types';
import React from 'react';

const carets = {
  full: {
    up: {
      viewBox: "0 0 30 18",
      path: "M29.728 15.683l-.17-.197L16.81.806C16.38.31 15.732 0 15.01 0c-.72 0-1.367.32-1.8.807L.47 15.457l-.215.245c-.16.234-.253.516-.253.816C0 17.334.694 18 1.556 18h26.888c.862 0 1.556-.666 1.556-1.482 0-.31-.103-.6-.272-.835"
    },
    down: {
      viewBox: "0 0 30 18",
      path: "M29.728 2.317l-.17.197-12.75 14.68c-.43.496-1.077.806-1.8.806-.72 0-1.367-.32-1.8-.807L.47 2.543l-.215-.245C.093 2.064 0 1.782 0 1.482 0 .666.694 0 1.556 0h26.888C29.306 0 30 .666 30 1.482c0 .31-.103.6-.272.835"
    },
    left: {
      viewBox: "0 0 18 30",
      path: "M15.683 29.728l-.197-.17L.806 16.81C.31 16.38 0 15.732 0 15.01c0-.72.32-1.367.807-1.8L15.457.47l.245-.215c.234-.16.516-.253.816-.253C17.334 0 18 .694 18 1.556v26.888c0 .862-.666 1.556-1.482 1.556-.31 0-.6-.103-.835-.272"
    },
    right: {
      viewBox: "0 0 18 30",
      path: "M2.317 29.728l.197-.17 14.68-12.75c.496-.43.806-1.077.806-1.8 0-.72-.32-1.367-.807-1.8L2.543.47 2.297.254C2.064.093 1.782 0 1.482 0 .666 0 0 .694 0 1.556v26.888C0 29.306.666 30 1.482 30c.31 0 .6-.103.835-.272"
    }
  },
  line: {
    up: {
      viewBox: "0 0 30 18",
      path: "M14.995 5.733l11.663 11.194c.288.282.764.275 1.058-.013l2.05-2.002c.294-.288.3-.756.012-1.038L15.538.204c-.148-.15-.35-.216-.543-.202-.2-.007-.395.06-.542.2L.213 13.875c-.29.282-.282.75.012 1.038l2.05 2.002c.293.288.77.295 1.057.013L14.995 5.733z"
    },
    down: {
      viewBox: "0 0 30 18",
      path: "M14.995 11.407L26.658.213c.288-.282.764-.275 1.058.013l2.05 2.002c.294.288.3.756.012 1.038l-14.24 13.67c-.148.15-.35.216-.543.202-.2.007-.395-.06-.542-.2L.213 3.265c-.29-.282-.282-.75.012-1.038L2.275.226c.293-.288.77-.295 1.057-.013l11.663 11.194z"
    },
    left: {
      viewBox: "0 0 18 30",
      path: "M5.74 14.99L16.936 3.333c.28-.288.275-.763-.013-1.058L14.92.224c-.288-.293-.756-.3-1.038-.012L.208 14.455c-.147.147-.214.348-.2.543-.007.2.06.395.2.542l13.674 14.237c.282.288.75.28 1.038-.014l2.003-2.05c.288-.294.294-.77.013-1.057L5.74 14.99z"
    },
    right: {
      viewBox: "0 0 18 30",
      path: "M11.403 14.99L.207 3.333c-.28-.288-.275-.763.013-1.058L2.222.224c.288-.293.757-.3 1.038-.012l13.675 14.243c.147.147.214.348.2.543.007.2-.06.395-.2.542L3.26 29.777c-.28.288-.75.28-1.038-.014L.22 27.713c-.288-.294-.294-.77-.013-1.057L11.403 14.99z"
    }
  }
};

function CaretIcon({type = "full", direction = "right"}) {
  const {[type]: {[direction]: caret} = {}} = carets;

  if (!caret) {
    throw new Error(`Invalid CaretIcon requested: ${type} ${direction}`);
  }

  return (
    <svg className="caret-icon" viewBox={caret.viewBox} xmlns="http://www.w3.org/2000/svg">
      <path d={caret.path} fillRule="evenodd"/>
    </svg>
  );
}

CaretIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  type: PropTypes.string.isRequired,
  direction: PropTypes.string.isRequired
};

export default CaretIcon


// WEBPACK FOOTER //
// ./modules/Common/components/svg/CaretIcon.js